/* INTEGY V441 — zero-result facet integrity owner.
   Hides inactive native facet values whose Shopify count is zero and prevents stale
   dynamically-inserted filter controls from navigating customers to empty pages. */
(function () {
  'use strict';

  var root = document.documentElement;
  var scanTimer = 0;
  var rowSelectors = [
    '[data-facet-filter-value]',
    '[data-filter-item]',
    '.faceted-filter-group-display__list-item',
    '.facets__item',
    '.filter-item',
    '[data-integy-v200-filter-row]',
    '[data-integy-v426-filter-chip]',
    '.integy-v353-static-filter-row',
    'li'
  ].join(',');

  function closestRow(node) {
    if (!node || !node.closest) return null;
    return node.closest(rowSelectors) || node;
  }

  function isActive(row) {
    if (!row) return false;
    if (row.classList && (row.classList.contains('is-active') || row.classList.contains('active') || row.classList.contains('selected'))) return true;
    if (row.getAttribute && (row.getAttribute('aria-checked') === 'true' || row.getAttribute('aria-selected') === 'true')) return true;
    var control = row.matches && row.matches('input,option') ? row : row.querySelector && row.querySelector('input,option,[aria-checked="true"]');
    return !!(control && (control.checked || control.selected || control.getAttribute('aria-checked') === 'true'));
  }

  function numericAttribute(node, names) {
    for (var i = 0; i < names.length; i += 1) {
      var raw = node && node.getAttribute ? node.getAttribute(names[i]) : null;
      if (raw == null || raw === '') continue;
      var value = Number(String(raw).replace(/[^0-9.-]/g, ''));
      if (Number.isFinite(value)) return value;
    }
    return null;
  }

  function countFor(row) {
    if (!row) return null;
    var count = numericAttribute(row, ['data-count','data-filter-count','data-facet-count','data-results-count','data-product-count']);
    if (count != null) return count;

    var control = row.querySelector && row.querySelector('input,option,a,button');
    count = numericAttribute(control, ['data-count','data-filter-count','data-facet-count','data-results-count','data-product-count']);
    if (count != null) return count;

    var countNode = row.querySelector && row.querySelector('[data-filter-count],.faceted-filter-group-display__list-item-label-count,.facets__count,.filter-count,.count');
    if (countNode) {
      var direct = String(countNode.textContent || '').match(/-?\d[\d,]*/);
      if (direct) return Number(direct[0].replace(/,/g, ''));
    }

    var text = String(row.textContent || '').replace(/\s+/g, ' ').trim();
    var trailing = text.match(/(?:\(|\[)\s*0\s*(?:\)|\])\s*$/);
    if (trailing) return 0;
    return null;
  }

  function isExplicitlyDisabled(row) {
    if (!row) return false;
    if (row.hidden || row.getAttribute('aria-disabled') === 'true' || row.hasAttribute('disabled')) return true;
    var control = row.querySelector && row.querySelector('input,button,option,a');
    return !!(control && (control.disabled || control.getAttribute('aria-disabled') === 'true'));
  }

  function markZero(row) {
    if (!row || isActive(row)) return;
    row.classList.add('integy-v441-zero-result');
    row.setAttribute('data-integy-v441-zero-result', 'true');
    row.setAttribute('aria-hidden', 'true');
    var controls = row.querySelectorAll ? row.querySelectorAll('a,button,input,option') : [];
    Array.prototype.forEach.call(controls, function (control) {
      control.setAttribute('aria-disabled', 'true');
      if (control.matches('a,button')) control.tabIndex = -1;
    });
  }

  function unmark(row) {
    if (!row || isActive(row) || row.getAttribute('data-integy-v441-zero-result') !== 'true') return;
    row.classList.remove('integy-v441-zero-result');
    row.removeAttribute('data-integy-v441-zero-result');
    if (row.getAttribute('aria-hidden') === 'true') row.removeAttribute('aria-hidden');
  }

  function scan(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var candidates = host.querySelectorAll([
      '[data-facet-filter-value]',
      '[data-filter-item]',
      '.faceted-filter-group-display__list-item',
      '.facets__item',
      '.filter-item',
      'input[name^="filter."]',
      'option[value*="filter."]'
    ].join(','));

    Array.prototype.forEach.call(candidates, function (candidate) {
      var row = closestRow(candidate);
      if (!row || isActive(row)) return;
      var count = countFor(row);
      if (count === 0 || (count == null && isExplicitlyDisabled(row))) markZero(row);
      else if (count != null && count > 0) unmark(row);
    });
    root.classList.add('integy-v441-filter-integrity-ready');
  }

  function schedule(scope) {
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () { scan(scope || document); }, 60);
  }

  document.addEventListener('click', function (event) {
    var blocked = event.target && event.target.closest ? event.target.closest('[data-integy-v441-zero-result="true"]') : null;
    if (!blocked) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }, true);

  function boot() {
    scan(document);
    if (window.MutationObserver) {
      var host = document.querySelector('main') || document.body;
      new MutationObserver(function (mutations) {
        if (mutations.some(function (mutation) { return mutation.addedNodes && mutation.addedNodes.length; })) schedule(host);
      }).observe(host, { childList: true, subtree: true });
    }
  }

  document.addEventListener('shopify:section:load', function (event) { schedule(event.target || document); });
  document.addEventListener('integy:v429:filter-rendered', function () { schedule(document); });
  window.addEventListener('pageshow', function () { schedule(document); });
  window.IntegyV441FilterIntegrity = { scan: scan };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
